module.exports = __webpack_public_path__ + "static/media/varais-9-copia.9bd8ed7e.jpg";